<template>
  <v-form ref="form" autocomplete="off">
    <div class="d-flex align-center ga-4 mb-4">
      <h2 class="font-weight-bold">
        Linea {{ this.descLinea }}
      </h2>
      <v-divider class="mx-4" inset vertical></v-divider>
    </div>
    <!-- ================= FILTRADO O CREACIÓN DE VALORES ================= -->
    <v-row>
      <!-- Filtro para buscar por descripción de valores la tabla con todos sus valores -->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="searchvalue"
          append-inner-icon="mdi-magnify"
          density="compact"
          clearable
          label="Buscar por valor de una Tabla"
          hint="Digite la descripción del valor de una tabla para buscar relaciones"
          variant="solo"
          hide-details
          single-line
          @click:append-inner="getArrayTableNumericId(false)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="6">
        <v-switch
          v-model="modelcreate"
          color="red-darken-3"
          label="¿Crear una Tabla Nueva?"
          hide-details
          inset
          @update:modelValue="getTablaValoracionId()"
        ></v-switch>
      </v-col>
    </v-row>

    <!-- ================= FORMULARIO ================= -->
    <v-row>
      <v-col v-if="!modelcreate" cols="4" md="4">
        <v-autocomplete
          v-model="editedItem.TablaAsignado"
          :items="ArrayTablaValoracion"
          item-title="Codigo"
          item-value="Codigo"
          color="primary"
          label="Tabla Numérica: "
          @update:modelValue="getConsultData"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <v-col v-else cols="4" md="4">
        <v-text-field
          v-model="editedItem.TablaAsignado"
          label="Tabla Numérica:"
          disabled
          dense
          maxlength="18"
          counter="18"
          type="tel"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Valor Menor -->
      <v-col cols="4" sm="4" md="4">
        <v-text-field
          v-model="editedItem.ValorInferior"
          label="Valor Mínimo:"
          clearable
          dense
          maxlength="18"
          counter="18"
          type="tel"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Valor Mayor -->
      <v-col cols="4" sm="4" md="4">
        <v-text-field
          v-model="editedItem.ValorSuperior"
          label="Valor Máximo:"
          clearable
          dense
          maxlength="18"
          counter="18"
          type="tel"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Descripción -->
      <v-col cols="4" sm="4" md="4">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción:"
          clearable
          dense
          maxlength="100"
          counter="100"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          type="text"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="blue" @click="adicionarProceso"> Adicionar </v-btn>
      </v-col>
    </v-row>

    <div align="right" class="mb-6">
      <v-btn color="green" @click="ValidateCampos"> Guardar </v-btn>
    </div>

    <!-- ================= TABLA DRAG ================= -->

    <v-card>
      <v-card>
        <v-card-title>
          Valores de Tabla
          <!-- Buscador -->
          <v-text-field
            v-model="search"
            append-inner-icon="mdi-magnify"
            label="Buscar..."
            single-line
            variant="underlined"
            hide-details
          ></v-text-field
        ></v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          item-value="id"
          show-expand
        >
          <template v-slot:item.Descripcion="{ item }">
            <!-- Descripción -->
            <v-text-field
              v-model="item.raw.Descripcion"
              label="Descripción:"
              clearable
              dense
              maxlength="100"
              counter="100"
              type="text"
            >
            </v-text-field>
          </template>

          <!-- Contenido que se expande -->
          <template v-slot:expanded-row="{ columns, item }">
            <tr>
              <td :colspan="columns.length">
                <v-row>
                  <v-col cols="12" sm="4" md="6">
                    <v-autocomplete
                      v-model="item.raw.Linea"
                      :items="ArrayLineas"
                      :item-title="
                        (ArrayLineas) =>
                          ArrayLineas.LineaCredito +
                          ' - ' +
                          ArrayLineas.Descripcion
                      "
                      item-value="LineaCredito"
                      color="primary"
                      label="Linea Bifurca:"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Proceso Bifurca -->
                  <v-col cols="12" sm="4" md="6">
                    <v-autocomplete
                      v-model="item.raw.Proceso"
                      :items="ArrayProcesos"
                      :item-title="
                        (ArrayProcesos) =>
                          ArrayProcesos.ProcesoId +
                          '-' +
                          ArrayProcesos.Descripcion
                      "
                      item-value="ProcesoId"
                      color="primary"
                      label="Proceso Bifurca:"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Dato Dependiente -->
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="item.raw.DatoDependiente"
                      :items="ArrayDatoDependiente"
                      :item-title="
                        (ArrayDatoDependiente) =>
                          ArrayDatoDependiente.Codigo +
                          '-' +
                          ArrayDatoDependiente.Descripcion
                      "
                      item-value="Codigo"
                      color="primary"
                      label="Dato Dependiente:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete
                  ></v-col>

                  <!-- Protegido Dato Dependiente -->
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="item.raw.ProtegidoDP"
                      :items="ArraySiNo"
                      :item-title="
                        (ArraySiNo) =>
                          ArraySiNo.Valor + ' - ' + ArraySiNo.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Visible Dato Dependiente:"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Visible Dato Dependiente -->
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="item.raw.VisibleDP"
                      :items="ArraySiNo"
                      :item-title="
                        (ArraySiNo) =>
                          ArraySiNo.Valor + ' - ' + ArraySiNo.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Protegido Dato Dependiente:"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Grupo de Documentos -->
                  <v-col cols="12" sm="4" md="6">
                    <v-autocomplete
                      v-model="item.raw.Grupo"
                      :items="ArrayGrupo"
                      :item-title="
                        (ArrayGrupo) =>
                          ArrayGrupo.GrpDocumentoID +
                          '-' +
                          ArrayGrupo.Descripcion
                      "
                      item-value="GrpDocumentoID"
                      color="primary"
                      label="Grupo de documentos:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Documentos -->
                  <v-col cols="12" sm="4" md="6">
                    <v-autocomplete
                      v-model="item.raw.Documento"
                      :items="ArrayDocumento"
                      :item-title="
                        (ArrayDocumento) =>
                          ArrayDocumento.DocumentoID +
                          '-' +
                          ArrayDocumento.Descripcion
                      "
                      item-value="DocumentoID"
                      color="primary"
                      label="Documento Unico:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Calificación -->
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field
                      v-model="item.raw.Calificacion"
                      label="Calificación Mínima:"
                      clearable
                      dense
                      maxlength="5"
                      counter="5"
                      type="tel"
                      v-on:keypress="isNumber()"
                    >
                    </v-text-field>
                  </v-col>

                  <!-- Evaluación -->
                  <v-col cols="12" sm="4" md="6">
                    <v-autocomplete
                      v-model="item.raw.Evaluacion"
                      :items="ArrayEvaluacion"
                      :item-title="
                        (ArrayEvaluacion) =>
                          ArrayEvaluacion.Valor +
                          '-' +
                          ArrayEvaluacion.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      label="Evaluación:"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-form>

  <!-- ================= PROGRESO ================= -->

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getAllValues,
  getValoracionNumerico,
  upsertValoracionNumerico,
  getAllDataTableMax,
} from "@/views/TCI/ProcesosP/ValoracionNumerica/ValoracionNumericaServices";
import { getAllDatos } from "@/views/TCI/ProcesosP/Datos/DatosService";
import { getAllProcess } from "@/views/TCI/ProcesosP/Procesos/ProcesosService";

export default {
  name: "valoracion-numerica",

  data() {
    return {
      progreso: false,
      search: "",
      descLinea: "",
      searchvalue: "",
      modelcreate: false,
      editedItem: {
        TablaAsignado: null,
        ValorInferior: null,
        ValorSuperior: null,
        Descripcion: null,
      },

      modelfiltro: [
        {
          campo: "Codigo",
          filtro: "=",
          contenido: null,
          lectura: false,
          clear: true,
          label: "Código:",
        },
      ],

      ArrayTablaValoracion: [],
      ArrayDatoDependiente: [],
      ArraySiNo: [],
      ArrayGrupo: [],
      ArrayDocumento: [],
      ArrayEvaluacion: [],
      ArrayLineas: [],
      ArrayProcesos: [],
      items: [],
      headers: [
        { title: "Tabla", key: "Codigo" },
        { title: "Valor Inferior", key: "ValorInferior" },
        { title: "Valor Superior", key: "ValorSuperior" },
        { title: "Descripción", key: "Descripcion" },
      ],
      items: [],
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    //Validación de filtros
    async ValidateCampos() {
      if (this.items.length === 0) {
        this.$swal({
          icon: "warning",
          title: "No hay procesos para guardar",
        });
        return;
      }

      this.progreso = true;

      try {
        await upsertValoracionNumerico(this.items);

        this.$swal({
          icon: "success",
          title: "Guardado correctamente",
        });

        this.getConsultData();
        this.getArrayTableNumericId(true);
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.items = [];
      this.modelfiltro[0].contenido = null;
      if (
        this.editedItem &&
        this.editedItem.TablaAsignado != null &&
        this.editedItem.TablaAsignado > 0
      ) {
        this.progreso = true;
        this.modelfiltro[0].contenido =
          this.editedItem.TablaAsignado.toString();

        var data = {
          filtrado: this.modelfiltro,
          busquedacompleta: true,
        };
        try {
          const result = await getValoracionNumerico(data);
          this.items = result;
        } catch (error) {
          console.error(error);
          const registro = error.data || {};
          const mensajeerror =
            registro.Mensaje ||
            registro.ExceptionMessage ||
            JSON.stringify(registro);

          if (error.status === 404) {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: mensajeerror,
            });
          } else {
            this.$swal({
              icon: "error",
              title: "Error al consultar",
              html:
                "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
                mensajeerror +
                "</code></small>",
            });
          }
        } finally {
          this.progreso = false;
          this.dialogframe = false;
        }
      }
    },

    async adicionarProceso() {
      if (
        !this.editedItem.TablaAsignado ||
        !this.editedItem.ValorInferior ||
        !this.editedItem.ValorSuperior ||
        !this.editedItem.Descripcion
      ) {
        this.$swal({
          icon: "warning",
          title: "Registre los campos obligatorios ",
        });
        this.$refs.form.validate();
        return;
      }

      // Evitar duplicados
      const existe = this.items.some(
        (item) =>
          item.Codigo === this.editedItem.TablaAsignado &&
          item.ValorInferior === this.editedItem.ValorInferior &&
          item.ValorSuperior === this.editedItem.ValorSuperior,
      );

      if (existe) {
        this.$swal({
          icon: "warning",
          title: "El valor de registro ya fue agregado",
        });
        return;
      }

      var userperfil = this.$store.getters.userperfil;

      // Agregar a la tabla
      this.items.push({
        Codigo: this.editedItem.TablaAsignado,
        ValorInferior: this.editedItem.ValorInferior,
        ValorSuperior: this.editedItem.ValorSuperior,
        Descripcion: this.editedItem.Descripcion,
        Linea: null,
        Proceso: null,
        Grupo: null,
        Documento: null,
        DatoDependiente: null,
        ProtegidoDP: "N",
        VisibleDP: "N",
        Calificacion: null,
        Evaluacion: null,
        UsuarioCreacion: userperfil.userInfo.Usuario_ID,
        UsuarioActualizacion: userperfil.userInfo.Usuario_ID,
      });

      // Limpiar selección
      this.editedItem.ValorInferior = null;
      this.editedItem.ValorSuperior = null;
      this.editedItem.Descripcion = null;
    },

    // Consulta Procesos
    async getProcesos() {
      this.ArrayProcesos = [];
      const result = await getAllProcess();
      this.ArrayProcesos = result;
    },

    // Consulta Id Tabla Valoracion
    async getTablaValoracionId() {
      this.editedItem.TablaAsignado = null;
      this.items = [];
      if (this.modelcreate) {
        const result = await getAllDataTableMax();
        this.editedItem.TablaAsignado = result;
      } else {
        this.getArrayTableNumericId(true);
      }
    },

    // Consulta Arreglo
    async getArrayTableNumericId(data) {
      this.ArrayTablaValoracion = [];
      if ((this.searchvalue != null && this.searchvalue != "") || data) {
        this.progreso = true;
        try {
          const result = await getAllValues(this.searchvalue);
          console.log(result);
          this.ArrayTablaValoracion = result;
        } catch (error) {
          console.error(error);
          const registro = error.data || {};
          const mensajeerror =
            registro.Mensaje ||
            registro.ExceptionMessage ||
            JSON.stringify(registro);

          if (error.status === 404) {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: mensajeerror,
            });
          } else {
            this.$swal({
              icon: "error",
              title: "Error al consultar",
              html:
                "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
                mensajeerror +
                "</code></small>",
            });
          }
        } finally {
          this.progreso = false;
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Registre el campo de filtro antes de consultar.",
          html: "Campo obligatorio",
        });
      }
    },

    // Consulta Datos
    async getDatos() {
      this.ArrayDatoDependiente = [];
      const result = await getAllDatos();
      this.ArrayDatoDependiente = result;
    },

    // Consulta Tablas Existentes
    async getAllValues() {
      this.ArrayDatoDependiente = [];
      const result = await getAllValues();
      this.ArrayDatoDependiente = result;
    },

    // Cargue Combos
    CargueCombos() {
      this.getDatos();
      this.getProcesos();

      var Tables = this.$store.getters.MTablaSeleccion;

      this.ArraySiNo = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 16,
      );

      this.ArrayEvaluacion = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 73,
      );

      this.ArrayGrupo = this.$store.getters.MGrupoDocumentos;
      this.ArrayDocumento = this.$store.getters.MDocumentos;
      this.getArrayTableNumericId(true);
      this.ArrayLineas = this.$store.getters.MLineas;
    },
  },

  mounted() {
    if (this.$route.query) {
      this.descLinea = this.$route.query.descLinea;
    }

    this.CargueCombos();
  },
};
</script>

<style>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
</style>
